/**
 * Decide whether AdSense should be asked to fill the ad slot inside `container`.
 *
 * AdSense fills each `<ins class="adsbygoogle">` exactly once and stamps it with a
 * `data-adsbygoogle-status` attribute afterwards. Calling `adsbygoogle.push({})`
 * again once every `<ins>` on the page is already filled makes AdSense throw a
 * benign `TagError` ("All 'ins' elements in the DOM with class=adsbygoogle already
 * have ads in them."). Because `runMotives()` re-runs on user engagement, settings
 * changes, ad rotation and prop updates, that error used to be raised — and logged
 * at ERROR — hundreds of thousands of times a day, flooding our logs.
 *
 * Guarding the push on the slot being present and not yet stamped prevents the
 * re-push (and therefore the error) at the source.
 */
export function canRequestAdSlot(container: Element | null | undefined): boolean {
    if (!container) {
        return false;
    }
    const ins = container.querySelector('ins.adsbygoogle');
    return !!ins && !ins.getAttribute('data-adsbygoogle-status');
}
